import { createAction, props } from '@ngrx/store';
import { Guid } from 'guid-typescript';

import { Article } from '@ca/core/models';

const prefix = '[Articles]';
const adminPrefix = '[Admin Articles]';

export const loadArticles = createAction(`${prefix} Load`);
export const loadArticlesSuccess = createAction(`${prefix} Loaded`, props<{ articles: Article[] }>());
export const loadArticlesFailed = createAction(`${prefix} Load failed`, props<{ error: unknown }>());
export const loadAdminArticles = createAction(`${adminPrefix} Load`);
export const loadAdminArticlesSuccess = createAction(`${adminPrefix} Loaded`, props<{ articles: Article[] }>());
export const loadAdminArticlesFailed = createAction(`${adminPrefix} Load failed`, props<{ error: unknown }>());
export const deleteArticle = createAction(`${adminPrefix} Delete Article`, props<{ id: Guid }>());
export const deleteArticleSuccess = createAction(`${adminPrefix} Deleted`, props<{ id: Guid }>());
export const deleteArticleFailed = createAction(`${adminPrefix} Delete failed`, props<{ error: unknown }>());
export const createArticle = createAction(`${adminPrefix} Create Article`, props<{ article: Article }>());
export const createArticleSuccess = createAction(`${adminPrefix} Created`, props<{ article: Article }>());
export const createArticleFailed = createAction(`${adminPrefix} Create failed`, props<{ error: unknown }>());
export const updateArticle = createAction(`${adminPrefix} Update Article`, props<{ article: Article }>());
export const updateArticleSuccess = createAction(`${adminPrefix} Updated`, props<{ article: Article }>());
export const updateArticleFailed = createAction(`${adminPrefix} Update failed`, props<{ error: unknown }>());
export const getArticle = createAction(`${adminPrefix} Get article`, props<{ id: Guid }>());
export const getArticleSuccess = createAction(`${adminPrefix} Get article success`, props<{ article: Article }>());
export const getArticleFailed = createAction(`${adminPrefix} Get article failed`, props<{ error: unknown }>());
export const resetError = createAction(`${adminPrefix} Reset error`);
export const resetArticleError = createAction(`${adminPrefix} Reset articleError`);
export const resetUpdateArticleSuccess = createAction(`${adminPrefix} Reset updateArticleSuccess`);
export const resetDeleteArticleSuccess = createAction(`${adminPrefix} Reset deleteArticleSuccess`);
